import { timestamps, uuid } from '@snap-types/models/common';
import { z } from 'zod/v4';

import { userRoleSchema } from '../enums';
import { userStatusSchema } from './enums';

export const columns = {
  id: uuid,
  oid: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  displayName: z.string(),
  email: z.string(),
  status: userStatusSchema,
  lastLogin: z.date(),
  userSettingsId: uuid.nullable(),
  role: userRoleSchema,
  ...timestamps,
};
